export function AboutPage() {
  return import('../../about');
}

export function EmojiPicker() {
  return import('../../emoji/components/emoji-picker');
}

export function Notifications() {
  return import('../../notifications');
}

export function LandingTimeline() {
  return import('../../landing-timeline');
}

export function HomeTimeline() {
  return import('../../home-timeline');
}

export function PublicTimeline() {
  return import('../../public-timeline');
}

export function RemoteTimeline() {
  return import('../../remote-timeline');
}

export function CommunityTimeline() {
  return import('../../community-timeline');
}

export function HashtagTimeline() {
  return import('../../hashtag-timeline');
}

export function DirectTimeline() {
  return import('../../direct-timeline');
}

export function Conversations() {
  return import('../../conversations');
}

export function ListTimeline() {
  return import('../../list-timeline');
}

export function Lists() {
  return import('../../lists');
}

export function Bookmarks() {
  return import('../../bookmarks');
}

export function Status() {
  return import('../../status');
}

export function PinnedStatuses() {
  return import('../../pinned-statuses');
}

export function AccountTimeline() {
  return import('../../account-timeline');
}

export function AccountGallery() {
  return import('../../account-gallery');
}

export function Followers() {
  return import('../../followers');
}

export function Following() {
  return import('../../following');
}

export function FollowRequests() {
  return import('../../follow-requests');
}

export function GenericNotFound() {
  return import('../../generic-not-found');
}

export function FavouritedStatuses() {
  return import('../../favourited-statuses');
}

export function Blocks() {
  return import('../../blocks');
}

export function DomainBlocks() {
  return import('../../domain-blocks');
}

export function Mutes() {
  return import('../../mutes');
}

export function MuteModal() {
  return import('../components/modals/mute-modal');
}

export function Filters() {
  return import('../../filters');
}

export function EditFilter() {
  return import('../../filters/edit-filter');
}

export function ReportModal() {
  return import('../components/modals/report-modal/report-modal');
}

export function AccountModerationModal() {
  return import('../components/modals/account-moderation-modal/account-moderation-modal');
}

export function MediaGallery() {
  return import('../../../components/media-gallery');
}

export function Video() {
  return import('../../video');
}

export function Audio() {
  return import('../../audio');
}

export function MediaModal() {
  return import('../components/modals/media-modal');
}

export function VideoModal() {
  return import('../components/modals/video-modal');
}

export function BoostModal() {
  return import('../components/modals/boost-modal');
}

export function ConfirmationModal() {
  return import('../components/modals/confirmation-modal');
}

export function MissingDescriptionModal() {
  return import('../components/modals/missing-description-modal');
}

export function ActionsModal() {
  return import('../components/modals/actions-modal');
}

export function HotkeysModal() {
  return import('../components/modals/hotkeys-modal');
}

export function ComposeModal() {
  return import('../components/modals/compose-modal');
}

export function ReplyMentionsModal() {
  return import('../components/modals/reply-mentions-modal');
}

export function UnauthorizedModal() {
  return import('../components/modals/unauthorized-modal');
}

export function EditFederationModal() {
  return import('../components/modals/edit-federation-modal');
}

export function EmbedModal() {
  return import('../components/modals/embed-modal');
}

export function ComponentModal() {
  return import('../components/modals/component-modal');
}

export function ReblogsModal() {
  return import('../components/modals/reblogs-modal');
}

export function FavouritesModal() {
  return import('../components/modals/favourites-modal');
}

export function DislikesModal() {
  return import('../components/modals/dislikes-modal');
}

export function ReactionsModal() {
  return import('../components/modals/reactions-modal');
}

export function MentionsModal() {
  return import('../components/modals/mentions-modal');
}

export function LandingPageModal() {
  return import('../components/modals/landing-page-modal');
}

export function BirthdaysModal() {
  return import('../components/modals/birthdays-modal');
}

export function BirthdayPanel() {
  return import('../../../components/birthday-panel');
}

export function ListEditor() {
  return import('../../list-editor');
}

export function ListAdder() {
  return import('../../list-adder');
}

export function Search() {
  return import('../../search');
}

export function LoginPage() {
  return import('../../auth-login/components/login-page');
}

export function ExternalLogin() {
  return import('../../external-login');
}

export function LogoutPage() {
  return import('../../auth-login/components/logout');
}

export function RegistrationPage() {
  return import('../../auth-login/components/registration-page');
}

export function Settings() {
  return import('../../settings');
}

export function EditProfile() {
  return import('../../edit-profile');
}

export function EditEmail() {
  return import('../../edit-email');
}

export function EmailConfirmation() {
  return import('../../email-confirmation');
}

export function EditPassword() {
  return import('../../edit-password');
}

export function DeleteAccount() {
  return import('../../delete-account');
}

export function SoapboxConfig() {
  return import('../../soapbox-config');
}

export function ExportData() {
  return import('../../export-data');
}

export function ImportData() {
  return import('../../import-data');
}

export function Backups() {
  return import('../../backups');
}

export function PasswordReset() {
  return import('../../auth-login/components/password-reset');
}

export function PasswordResetConfirm() {
  return import('../../auth-login/components/password-reset-confirm');
}

export function MfaForm() {
  return import('../../security/mfa-form');
}

export function ChatIndex() {
  return import('../../chats');
}

export function ChatWidget() {
  return import('../../chats/components/chat-widget/chat-widget');
}

export function ServerInfo() {
  return import('../../server-info');
}

export function Dashboard() {
  return import('../../admin');
}

export function ModerationLog() {
  return import('../../admin/moderation-log');
}

export function ThemeEditor() {
  return import('../../theme-editor');
}

export function UserPanel() {
  return import('../components/user-panel');
}

export function PromoPanel() {
  return import('../components/promo-panel');
}

export function SignUpPanel() {
  return import('../components/panels/sign-up-panel');
}

export function CtaBanner() {
  return import('../components/cta-banner');
}

export function FundingPanel() {
  return import('../components/funding-panel');
}

export function TrendsPanel() {
  return import('../components/trends-panel');
}

export function ProfileInfoPanel() {
  return import('../components/profile-info-panel');
}

export function ProfileMediaPanel() {
  return import('../components/profile-media-panel');
}

export function ProfileFieldsPanel() {
  return import('../components/profile-fields-panel');
}

export function PinnedAccountsPanel() {
  return import('../components/pinned-accounts-panel');
}

export function InstanceInfoPanel() {
  return import('../components/instance-info-panel');
}

export function InstanceModerationPanel() {
  return import('../components/instance-moderation-panel');
}

export function LatestAccountsPanel() {
  return import('../../admin/components/latest-accounts-panel');
}

export function SidebarMenu() {
  return import('../../../components/sidebar-menu');
}

export function ModalContainer() {
  return import('../containers/modal-container');
}

export function ProfileHoverCard() {
  return import('soapbox/components/profile-hover-card');
}

export function StatusHoverCard() {
  return import('soapbox/components/status-hover-card');
}

export function CryptoDonate() {
  return import('../../crypto-donate');
}

export function CryptoDonatePanel() {
  return import('../../crypto-donate/components/crypto-donate-panel');
}

export function CryptoAddress() {
  return import('../../crypto-donate/components/crypto-address');
}

export function CryptoDonateModal() {
  return import('../components/modals/crypto-donate-modal');
}

export function ScheduledStatuses() {
  return import('../../scheduled-statuses');
}

export function UserIndex() {
  return import('../../admin/user-index');
}

export function FederationRestrictions() {
  return import('../../federation-restrictions');
}

export function Aliases() {
  return import('../../aliases');
}

export function Migration() {
  return import('../../migration');
}

export function ScheduleForm() {
  return import('../../compose/components/schedule-form');
}

export function WhoToFollowPanel() {
  return import('../components/who-to-follow-panel');
}

export function FollowRecommendations() {
  return import('../../follow-recommendations');
}

export function Directory() {
  return import('../../directory');
}

export function RegisterInvite() {
  return import('../../register-invite');
}

export function Share() {
  return import('../../share');
}

export function NewStatus() {
  return import('../../new-status');
}

export function IntentionalError() {
  return import('../../intentional-error');
}

export function Developers() {
  return import('../../developers');
}

export function CreateApp() {
  return import('../../developers/apps/create');
}

export function SettingsStore() {
  return import('../../developers/settings-store');
}

export function TestTimeline() {
  return import('../../test-timeline');
}

export function ServiceWorkerInfo() {
  return import('../../developers/service-worker-info');
}

export function DatePicker() {
  return import('../../birthdays/date-picker');
}

export function OnboardingWizard() {
  return import('../../onboarding/onboarding-wizard');
}

export function CompareHistoryModal() {
  return import('../components/modals/compare-history-modal');
}

export function AuthTokenList() {
  return import('../../auth-token-list');
}

export function FamiliarFollowersModal() {
  return import('../components/modals/familiar-followers-modal');
}

export function AnnouncementsPanel() {
  return import('../../../components/announcements/announcements-panel');
}

export function Quotes() {
  return import('../../quotes');
}

export function ComposeEventModal() {
  return import('../components/modals/compose-event-modal/compose-event-modal');
}

export function JoinEventModal() {
  return import('../components/modals/join-event-modal');
}

export function EventHeader() {
  return import('../../event/components/event-header');
}

export function EventInformation() {
  return import('../../event/event-information');
}

export function EventDiscussion() {
  return import('../../event/event-discussion');
}

export function EventMapModal() {
  return import('../components/modals/event-map-modal');
}

export function EventParticipantsModal() {
  return import('../components/modals/event-participants-modal');
}

export function Events() {
  return import('../../events');
}

export function Groups() {
  return import('../../groups');
}

export function GroupsDiscover() {
  return import('../../groups/discover');
}

export function GroupsPopular() {
  return import('../../groups/popular');
}

export function GroupsSuggested() {
  return import('../../groups/suggested');
}

export function GroupsTag() {
  return import('../../groups/tag');
}

export function GroupsTags() {
  return import('../../groups/tags');
}

export function PendingGroupRequests() {
  return import('../../groups/pending-requests');
}

export function GroupMembers() {
  return import('../../group/group-members');
}

export function GroupTags() {
  return import('../../group/group-tags');
}

export function GroupTagTimeline() {
  return import('../../group/group-tag-timeline');
}

export function GroupTimeline() {
  return import('../../group/group-timeline');
}

export function ManageGroup() {
  return import('../../group/manage-group');
}

export function EditGroup() {
  return import('../../group/edit-group');
}

export function GroupBlockedMembers() {
  return import('../../group/group-blocked-members');
}

export function GroupMembershipRequests() {
  return import('../../group/group-membership-requests');
}

export function GroupGallery() {
  return import('../../group/group-gallery');
}

export function CreateGroupModal() {
  return import('../components/modals/manage-group-modal/create-group-modal');
}

export function NewGroupPanel() {
  return import('../components/panels/new-group-panel');
}

export function MyGroupsPanel() {
  return import('../components/panels/my-groups-panel');
}

export function SuggestedGroupsPanel() {
  return import('../components/panels/suggested-groups-panel');
}

export function GroupMediaPanel() {
  return import('../components/group-media-panel');
}

export function NewEventPanel() {
  return import('../components/panels/new-event-panel');
}

export function Announcements() {
  return import('../../admin/announcements');
}

export function EditAnnouncementModal() {
  return import('../components/modals/edit-announcement-modal');
}

export function FollowedTags() {
  return import('../../followed-tags');
}

export function AccountNotePanel() {
  return import('../components/panels/account-note-panel');
}

export function ComposeEditor() {
  return import('../../compose/editor');
}
